(function () {
  if (window.cbCertificateDrawerReady) return;
  window.cbCertificateDrawerReady = true;

  var lastTrigger = null;

  function openDrawer(drawer, trigger) {
    if (!drawer) return;

    lastTrigger = trigger || null;

    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cb-cert-drawer-open');

    window.setTimeout(function () {
      var closeButton = drawer.querySelector('[data-cb-cert-close]');
      if (closeButton) closeButton.focus();
    }, 220);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cb-cert-drawer-open');

    if (lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus();
    }

    lastTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-cb-cert-open]');

    if (openTrigger) {
      event.preventDefault();

      var drawerId = openTrigger.getAttribute('data-cb-cert-open');
      var drawer = document.getElementById(drawerId);

      openDrawer(drawer, openTrigger);
      return;
    }

    var closeTrigger = event.target.closest('[data-cb-cert-close]');

    if (closeTrigger) {
      event.preventDefault();

      var drawer = closeTrigger.closest('[data-cb-cert-drawer]');

      if (!drawer) {
        drawer = document.querySelector('[data-cb-cert-drawer].is-open');
      }

      closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var drawer = document.querySelector('[data-cb-cert-drawer].is-open');

    if (drawer) {
      closeDrawer(drawer);
    }
  });
})();